import React from "react";
import { pageLoader } from "@/assets";
import { cn } from "@/utils";

type TPageLoaderProps = {
  className?: string;
};

/**
 * A full-page loader component that displays the application's standard
 * loading spinner centered on the screen.
 * Intended for use as a Suspense fallback.
 */
const PageLoader: React.FC<TPageLoaderProps> = ({ className }) => {
  return (
    <div
      data-testid="page-loader-container"
      className={cn(
        "h-screen flex flex-col items-center justify-center",
        className,
      )}
    >
      <img
        src={pageLoader}
        width="80px"
        alt="page loader"
        data-testid="page-loader"
      />
    </div>
  );
};

export default PageLoader;
